import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Modal } from 'bootstrap';

import { appInfo } from './Settings';
import './App.scss';
import Footer from './Footer';
import Header from './Header';
import HomePage from '../pages/home';
import ArticleContentPage from "../pages/article-content-page/ArticleContentPage";
import ContactModal from "../shared/contact-modal/ContactModal";
import SupportModal from "../shared/contact-modal/SupportModal";
import DeliveriesModal from "../shared/deliveries-modal/DeliveriesModal";
import CustomerSayPage from "../pages/customer-say/CustomerSayPage";
import { MessageBox } from "../shared/message-box";

function App() {
  const ScrollToHash = () => {
    const { hash } = useLocation();

    useEffect(() => {
      if (!hash) return;
      
      setTimeout(() => {
        const el = document.getElementById(hash.replace('#', ''));
        if (!el) return;
        
        window.scrollTo({ 
          top: el.offsetTop, 
          behavior: 'smooth' 
        });
      }, 150);
    }, [hash]);

    return null;
  };

  const QueryParamModalOpener = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const hasContactUsFlag = params.has('contact-us');
      const modalParam = params.get('modal');

      const openModalById = (modalId) => {
        // Delay to ensure modal DOM is present
        setTimeout(() => {
          const el = document.getElementById(modalId);
          if (!el) return;
          const instance = Modal.getOrCreateInstance(el);
          instance.show();

          const handleHidden = () => {
            const newParams = new URLSearchParams(location.search);
            newParams.delete('contact-us');
            if (newParams.get('modal') === 'contact-us') newParams.delete('modal');
            navigate({ pathname: location.pathname, search: newParams.toString() ? `?${newParams.toString()}` : '' }, { replace: true });
            el.removeEventListener('hidden.bs.modal', handleHidden);
          };
          el.addEventListener('hidden.bs.modal', handleHidden);
        }, 0);
        return true;
      };

      if (hasContactUsFlag || modalParam === 'contact-us') {
        openModalById('contactUsModal');
      }
    }, [location.search, location.pathname, navigate]);

    return null;
  };

  return (
    <>
      <div className="app d-flex flex-column min-vh-100">
        <Header {...appInfo.header} />
        <main className="flex-grow-1">
          <Router>
            <ScrollToHash />
            <QueryParamModalOpener />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/testimonials" element={<CustomerSayPage />} />
              <Route path="/services/*" element={<ArticleContentPage />} />
              <Route path="/cloud-solutions/*" element={<ArticleContentPage />} />
              <Route path="/terms-and-conditions" element={<ArticleContentPage />} />
              <Route path="/privacy-policy" element={<ArticleContentPage />} />
              <Route path="/purchasing-policy" element={<ArticleContentPage />} />
              <Route path="/404.html" element={<div>Page not found</div>} />
              <Route path="*" element={<div>Page not found</div>} />
            </Routes>
          </Router>
        </main>
        <Footer {...appInfo.footer} />
      </div>
      <ContactModal />
      <SupportModal />
      <DeliveriesModal />
      <MessageBox />
    </>
  );
}

export default App;
